import { doGetMappingUser, doPost } from "../api/baseAPI";
import { setClientId, setFirstName, setGrologAccId, setLanguage, setLastName, setMappingUser, setMenu, setPermission, setRole, setUserId, setUsername } from "../store/reducer/authentication.reducer";
import { BASE_URL } from "../constant/apiConstant";

export const getMappingUser = async (token, dispatch) => {
  let status = { isGetUser: false };
  const url = `${BASE_URL}/auth/authorize/get-user`;

  try {
    const response = await doGetMappingUser(url, token);

    if (response?.status === 200) {
      const data = response?.data?.payload;
      dispatch(setMappingUser(data));
      status.isGetUser = true;
    }
  } catch (error) {
    return error
  }

  return status;

}

export const setUser = async (token, data, dispatch) => {
  let status = { isSetUser: false };
  const url = `${BASE_URL}/auth/authorize/set-user`;

  try {
    const res = await doPost(url, token, data);

    if (res?.status === 200) {
      const dataResult = res?.data?.payload;
      console.log("check response", dataResult);
      dispatch(setFirstName(dataResult?.first_name))
      dispatch(setLastName(dataResult?.last_name))
      dispatch(setLanguage(dataResult?.locale))
      dispatch(setGrologAccId(dataResult?.grolog_account_id))
      dispatch(setUsername(dataResult?.username))
      dispatch(setRole(dataResult?.role))
      dispatch(setUserId(dataResult?.user_id))
      dispatch(setClientId(data?.client_id))
      dispatch(setPermission(dataResult?.permission))
      dispatch(setMenu(dataResult?.menu))
      status.isSetUser = true;
    }
  } catch (error) {
    return error
  }

  return status;

}